import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IconKey } from '../../../../../../../whitelabel/icon-key.enum';
import { ButtonComponent } from '../../../../../../osp-ui/components/button/button/button.component';
import { IconComponent } from '../../../../../../osp-ui/components/icon/icon/icon.component';
import { TooltipDirective } from '../../../../../../osp-ui/components/overlay/tooltip/tooltip.directive';
import { IconPipe } from '../../../../../../shared/pipes/icon.pipe';

@Component({
  selector: 'osp-acknowledge-notification-button',
  standalone: true,
  imports: [ButtonComponent, IconComponent, IconPipe, TooltipDirective, TranslateModule],
  templateUrl: './acknowledge-notification-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AcknowledgeNotificationButtonComponent {
  readonly IconKey = IconKey;

  $tooltip = input<string>('', { alias: 'tooltip' });
  $disabled = input<boolean>(false, { alias: 'disabled' });
  onClick = output();
}
